import * as React from 'react'
import { ChangeEvent, FormEvent, useState, useEffect } from 'react'
import { useLocation } from 'react-router-dom'

import Autosuggest from 'react-autosuggest'
import { FieldInputProps, FormikHelpers, FormikValues } from 'formik'

import { ProfileShort } from '../../../store/commonTypes'

import { getProfiles } from '../../../api/profiles'
import isNull from 'lodash/isNull'
import './styles.sass'
import '../form.sass'
import './../../ui/textInput/textInput.sass'

interface Props {
    label?: string
    placeholder?: string
    field: FieldInputProps<string>
    form: FormikHelpers<FormikValues>
    filterSuggestions: (suggestions: ProfileShort[]) => ProfileShort[]
}

const AutosuggestField: React.FunctionComponent<Props> = ({
    form,
    field,
    label,
    placeholder,
    filterSuggestions
}: Props) => {
    const location = useLocation()

    const [suggestions, setSuggestions] = useState<ProfileShort[]>([])
    const [value, setValue] = useState('')

    const onChange = (e: ChangeEvent<HTMLInputElement>, { newValue }: Autosuggest.ChangeEvent) => {
        form.setFieldValue(field.name, newValue)
        setValue(newValue)
    }

    const getSuggestionValue = (suggestion: ProfileShort) => suggestion.nick

    const renderSuggestion = (suggestion: ProfileShort) => <span>{suggestion.nick}</span>

    const loadSuggestions = (query: string) => {
        getProfiles({ query, suggest: 1 })
            .then((res) => {
                setSuggestions(filterSuggestions([...res.list]))
            })
            .catch((e) => console.log(e))
    }

    const onSuggestionsFetchRequested = ({ value }: Autosuggest.SuggestionsFetchRequestedParams) => {
        loadSuggestions(value)
    }

    const onSuggestionsClearRequested = () => {
        setSuggestions([])
    }

    const onSuggestionSelected = (
        e: FormEvent<HTMLInputElement>,
        { suggestion }: Autosuggest.SuggestionSelectedEventData<ProfileShort>
    ) => {
        form.setFieldValue(field.name, suggestion.nick)
    }

    const inputProps = {
        placeholder,
        onChange,
        value
    }

    useEffect(() => {
        if (location.search) {
            const user = new URLSearchParams(location.search).get('user')
            if (user) {
                setValue(user)
                form.setFieldValue(field.name, user)
            }
        }
    }, [location])

    useEffect(() => {
        if (isNull(field.value) && !location.search) setValue('')
    }, [field.value])

    return (
        <div className="form__fieldContainer">
            <div className="textInput">
                {label && <label htmlFor={field.name}>{label}</label>}
                <Autosuggest
                    inputProps={inputProps}
                    suggestions={suggestions}
                    renderSuggestion={renderSuggestion}
                    getSuggestionValue={getSuggestionValue}
                    onSuggestionSelected={onSuggestionSelected}
                    onSuggestionsFetchRequested={onSuggestionsFetchRequested}
                    onSuggestionsClearRequested={onSuggestionsClearRequested}
                />
            </div>
        </div>
    )
}

export default AutosuggestField
